function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { Table, Button, Card, InputGroup, OverlayTrigger, Row, Tooltip, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { useSelector } from 'react-redux';
import { helpPages } from './Help';
import TeachingBubble from '@rd-web-markets/shared/dist/util/TeachingBubble';
import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import { ChangeHighlighter } from '@rd-web-markets/shared/dist/util/ChangeHighlighter';
import { HelpItem } from '@rd-web-markets/shared/dist/util';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util/FormattedNumberInput';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import { useGetUserClaimAbilities } from '../../userAbilities';
import TotalCostTabs from './TotalCostTabs';
export const TotalCostsSection = _ref => {
  let {
    accountType,
    claim,
    saveClaim,
    setClaim
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const pageAbilities = useGetUserClaimAbilities({
    user,
    claim
  }).pages.TotalCosts;
  const [estimated, setEstimated] = useState(false);
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    setEstimated(claim.loss_surrendered_for_tax_credits !== null && (!claim.is_long_claim_period || claim.loss_surrendered_for_tax_credits_2nd_ct !== null));
  }, [claim]);
  if (!user || !claim) return /*#__PURE__*/React.createElement(Loading, null);
  const financialsComplete = claim.completed_percent_financial[user.account_type] > 96;
  const handleChange = e => {
    setClaim(_objectSpread(_objectSpread({}, claim), {}, {
      [e.target.name]: e.target.value
    }));
  };
  const currencyFormatter = new Intl.NumberFormat('en-GB');
  const percentageFormatter = new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-end mb-2"
  }, /*#__PURE__*/React.createElement(TeachingBubble, {
    pages: helpPages,
    position: "left"
  })), /*#__PURE__*/React.createElement(TotalCostTabs, {
    claim: claim,
    setClaim: setClaim,
    saveClaim: saveClaim
  }));
};